(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[169],{

/***/ 92994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ ActionModal_ActionModal; },
  "z": function() { return /* reexport */ ActionModal_ActionModalItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Modal/index.js + 1 modules
var Modal = __webpack_require__(97971);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./components/ActionModal/ActionModal.module.scss
var ActionModal_module = __webpack_require__(97346);
var ActionModal_module_default = /*#__PURE__*/__webpack_require__.n(ActionModal_module);
;// CONCATENATED MODULE: ./components/ActionModal/ActionModal.tsx







var cx = bind_default().bind((ActionModal_module_default()));
var ActionModal = function(param) {
    var _children = param.children, children = _children === void 0 ? null : _children, isOpen = param.isOpen, closeModal = param.closeModal, t = param.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        closeModal: closeModal,
        isOpen: isOpen,
        isFullWidth: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: cx("action-modal__body"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("action-modal__list"),
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonWithIconOnly */.Au, {
                    appearance: "knockout",
                    "aria-label": t("Close modal"),
                    className: cx("action-modal__close-button"),
                    onClick: closeModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "x-dismiss"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ActionModal_ActionModal = (ActionModal);

// EXTERNAL MODULE: ./components/ActionModal/ActionModalItem.module.scss
var ActionModalItem_module = __webpack_require__(11595);
var ActionModalItem_module_default = /*#__PURE__*/__webpack_require__.n(ActionModalItem_module);
;// CONCATENATED MODULE: ./components/ActionModal/ActionModalItem.tsx




var ActionModalItem_cx = bind_default().bind((ActionModalItem_module_default()));
var ActionModalItem = function(param) {
    var children = param.children, _isDanger = param.isDanger, isDanger = _isDanger === void 0 ? false : _isDanger, title = param.title, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: ActionModalItem_cx("action-modal-item", {
            "action-modal-item--danger": isDanger
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: ActionModalItem_cx("action-modal-item__button"),
            role: "button",
            tabIndex: 0,
            title: title,
            onClick: onClick,
            onKeyPress: onClick,
            children: children
        })
    });
};
/* harmony default export */ var ActionModal_ActionModalItem = (ActionModalItem);

;// CONCATENATED MODULE: ./components/ActionModal/index.ts





/***/ }),

/***/ 54812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HighlightContainer_HighlightContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/linkifyjs/dist/linkify.module.js
var linkify_module = __webpack_require__(51854);
// EXTERNAL MODULE: ./node_modules/react-highlight-words/dist/main.js
var main = __webpack_require__(37763);
var main_default = /*#__PURE__*/__webpack_require__.n(main);
// EXTERNAL MODULE: ./utils/regex/index.ts
var regex = __webpack_require__(14255);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./components/HighlightArea/Highlight/Highlight.module.scss
var Highlight_module = __webpack_require__(12114);
var Highlight_module_default = /*#__PURE__*/__webpack_require__.n(Highlight_module);
;// CONCATENATED MODULE: ./components/HighlightArea/Highlight/Highlight.tsx












var cx = bind_default().bind((Highlight_module_default()));
var Highlight = function(param) {
    var highlightMatch = param.highlightMatch, mentionClassName = param.className, emailAndLinkMap = param.emailAndLinkMap, userIdToAvatarMap = param.userIdToAvatarMap;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), trackEvent = ref.trackEvent, currentUser = ref.currentUser;
    var t = (0,es/* useTranslation */.$G)().t;
    var userMentionRef = (0,react.useRef)(null);
    var isMention = highlightMatch.match(regex/* MENTION_REGEX */.xA);
    var name = isMention && "".concat(highlightMatch.substring(highlightMatch.indexOf("[") + 1, highlightMatch.lastIndexOf("]"))) || t("User not found");
    var userId = isMention && "".concat(highlightMatch.substring(highlightMatch.indexOf("(") + 1, highlightMatch.lastIndexOf(")"))) || "";
    var onKeyDown = function(event) {
        if (event.key === "Enter" || event.key === " ") {
            handleOpenUserProfilePanel(event);
        }
    };
    var avatarUrl = userIdToAvatarMap === null || userIdToAvatarMap === void 0 ? void 0 : userIdToAvatarMap[userId];
    var handleOpenUserProfilePanel = function(event) {
        event.preventDefault();
        event.stopPropagation();
        PubSub.publish(eventNames/* eventNames.OPEN_PROFILE_PANEL */.S.OPEN_PROFILE_PANEL, {
            userId: userId,
            lastElementRef: userMentionRef
        });
        trackEvent(trackingEvents/* default.PROFILE_PANEL_TAB_OPENED */.ZP.PROFILE_PANEL_TAB_OPENED, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.WAS_OPENED_FROM_MENTION */.Ku.WAS_OPENED_FROM_MENTION, true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMention ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
            className: cx("mention__tooltip"),
            displayElements: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                avatarUrl: avatarUrl,
                className: cx("user__avatar"),
                size: "xs",
                srcSet: "".concat(avatarUrl, "?width=40 1x, ").concat(avatarUrl, "?width=40&dpr=2 2x, ").concat(avatarUrl, "?width=40&dpr=3 3x"),
                userId: userId || "",
                username: name
            }),
            displayElementsClassName: cx("mention__tooltip-display"),
            innerClassName: cx("mention__tooltip-inner"),
            placement: "top",
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                children: name
            }),
            isDark: true,
            isOpaque: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                "aria-hidden": false,
                "aria-label": name,
                className: cx(mentionClassName.trim(), {
                    "current-user": currentUser.id === userId
                }),
                "data-qa": "mentions__highlight",
                ref: userMentionRef,
                role: "button",
                tabIndex: 0,
                onClick: handleOpenUserProfilePanel,
                onKeyDown: onKeyDown,
                children: [
                    "@",
                    name
                ]
            })
        }, name) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "data-qa": "link__highlight",
            href: emailAndLinkMap[highlightMatch],
            target: "_blank",
            onClick: function(event) {
                return event.stopPropagation();
            },
            children: highlightMatch
        })
    });
};
/* harmony default export */ var Highlight_Highlight = (Highlight);

;// CONCATENATED MODULE: ./components/HighlightArea/HighlightContainer/HighlightContainer.tsx







var HighlightContainer = function(param) {
    var content = param.content, mentionedUsers = param.mentionedUsers;
    var ref;
    var emailAndLinkValues = [];
    var emailAndLinkMap = {};
    var userIdToAvatarMap = {};
    var arrayOfEmailsAndLinks = linkify_module/* find */.sE(content);
    emailAndLinkValues = arrayOfEmailsAndLinks.filter(function(node) {
        var isValid = true;
        try {
            /* eslint-disable no-debugger, no-new */ new RegExp(node.value);
        } catch (e) {
            isValid = false;
        }
        return isValid;
    }).map(function(node) {
        emailAndLinkMap[node.value] = node.href;
        return (0,regex/* escapeRegex */.yI)(node.value);
    });
    mentionedUsers === null || mentionedUsers === void 0 ? void 0 : (ref = mentionedUsers.edges) === null || ref === void 0 ? void 0 : ref.forEach(function(mentionedUser) {
        var ref;
        var id = mentionedUser === null || mentionedUser === void 0 ? void 0 : (ref = mentionedUser.node) === null || ref === void 0 ? void 0 : ref.id;
        if (id) {
            var ref1;
            userIdToAvatarMap[id] = (mentionedUser === null || mentionedUser === void 0 ? void 0 : (ref1 = mentionedUser.node) === null || ref1 === void 0 ? void 0 : ref1.avatarUrl) || "";
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((main_default()), {
        highlightClassName: "mentions-highlight",
        highlightTag: function(results) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight_Highlight, {
                className: results.className,
                emailAndLinkMap: emailAndLinkMap,
                highlightMatch: results.children,
                userIdToAvatarMap: userIdToAvatarMap
            });
        },
        searchWords: (0,_to_consumable_array/* default */.Z)(emailAndLinkValues).concat([
            regex/* MENTION_REGEX */.xA
        ]),
        textToHighlight: content,
        caseSensitive: true
    });
};
/* harmony default export */ var HighlightContainer_HighlightContainer = (HighlightContainer);

;// CONCATENATED MODULE: ./components/HighlightArea/HighlightContainer/index.ts



/***/ }),

/***/ 80169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Post_Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(63659);
// EXTERNAL MODULE: ./helpers/spaceHelpers.ts
var spaceHelpers = __webpack_require__(68556);
// EXTERNAL MODULE: ./components/HighlightArea/HighlightContainer/index.ts + 2 modules
var HighlightContainer = __webpack_require__(54812);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./components/PostActions/index.ts + 3 modules
var PostActions = __webpack_require__(29035);
// EXTERNAL MODULE: ./components/ReactionButton/index.ts + 3 modules
var ReactionButton = __webpack_require__(44215);
// EXTERNAL MODULE: ./helpers/reactionHelpers.ts
var reactionHelpers = __webpack_require__(72579);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Loader-fe940c7c.js
var Loader_fe940c7c = __webpack_require__(75826);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/toaster-a57afb61.js
var toaster_a57afb61 = __webpack_require__(81792);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./utils/mentions/index.ts
var mentions = __webpack_require__(29296);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./schema/Post/queries.ts
var queries = __webpack_require__(95313);
// EXTERNAL MODULE: ./koba/components/InlineActions/constants.js
var InlineActions_constants = __webpack_require__(98939);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./helpers/dateHelpers/index.ts
var dateHelpers = __webpack_require__(17981);
// EXTERNAL MODULE: ./schema/Post/mutations.ts
var mutations = __webpack_require__(74266);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./components/UserDetail/index.ts + 1 modules
var UserDetail = __webpack_require__(50826);
// EXTERNAL MODULE: ./components/Post/Post.module.scss
var Post_module = __webpack_require__(82845);
var Post_module_default = /*#__PURE__*/__webpack_require__.n(Post_module);
;// CONCATENATED MODULE: ./components/Post/Post.tsx






































var cx = bind_default().bind((Post_module_default()));
// Define outside of the component so all post components can share the same imports
var ExpandableTextArea;
var MentionsTextArea;
var CommentListSingular;
var AddCommentModal;
var CommentList;
var AddCommentContainer;
var AttachmentDisplayer;
var EditPostModal;
var Post = function(param) {
    var _additionalClassName = param.additionalClassName, additionalClassName = _additionalClassName === void 0 ? "" : _additionalClassName, content = param.content, mentionedUsers = param.mentionedUsers, author = param.author, post = param.post, time = param.time, t = param.t, _isPostPage = param.isPostPage, isPostPage = _isPostPage === void 0 ? false : _isPostPage, refetchPostList = param.refetchPostList, totalCommentCount = param.totalCommentCount, postReactionCount = param.postReactionCount, goToPostListPage = param.goToPostListPage, _lastCommentRef = param.lastCommentRef, lastCommentRef = _lastCommentRef === void 0 ? {} : _lastCommentRef, _communityWrapperRef = param.communityWrapperRef, communityWrapperRef = _communityWrapperRef === void 0 ? {} : _communityWrapperRef, _shouldShowTagOnPost = param.shouldShowTagOnPost, shouldShowTagOnPost = _shouldShowTagOnPost === void 0 ? false : _shouldShowTagOnPost, onPostChange = param.onPostChange;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref6.community, currentUser = ref6.currentUser, trackEvent = ref6.trackEvent;
    var firstAttachment = post === null || post === void 0 ? void 0 : (ref = post.postAttachments) === null || ref === void 0 ? void 0 : ref[0];
    var refetchQueries = [
        {
            query: queries/* POST_LIST_QUERY */.c,
            variables: {
                communityId: community.id,
                numOfPosts: constants/* POSTS_PER_PAGE */.DB,
                filter: {
                    following: true
                },
                postOrderField: undefined,
                numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
            }
        }, 
    ];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* UNFOLLOW_POST_MUTATION */.JB, {
        refetchQueries: refetchQueries
    }), 2), unfollowPost = ref7[0], ref8 = ref7[1], unfollowLoading = ref8.loading;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* FOLLOW_POST_MUTATION */.ZH, {
        refetchQueries: refetchQueries
    }), 2), followPost = ref9[0], ref10 = ref9[1], followLoading = ref10.loading;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* PIN_POST_MUTATION */.O7), 2), pinPost = ref11[0], ref12 = ref11[1], pinLoading = ref12.loading;
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* UNPIN_POST_MUTATION */.Nw), 2), unpinPost = ref13[0], ref14 = ref13[1], unpinLoading = ref14.loading;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* BREAKPOINT_MD */.GI;
    var ref15 = (0,react.useState)(false), isOpen = ref15[0], setIsOpen = ref15[1];
    var ref16 = (0,react.useState)(false), isEditModalOpen = ref16[0], setIsEditModalOpen = ref16[1];
    var ref17 = (0,react.useState)(((content === null || content === void 0 ? void 0 : content.length) || 0) > 480), shouldClampContent = ref17[0], setShouldClampContent = ref17[1];
    var router = (0,next_router.useRouter)();
    var commentIdFromURL = router && router.query && router.query.comment;
    var ref18 = (0,react.useState)(commentIdFromURL), commentId = ref18[0], setCommentId = ref18[1];
    (0,react.useEffect)(function() {
        setCommentId(commentIdFromURL);
    }, [
        commentIdFromURL
    ]);
    // Load all the things
    if (isPostPage) {
        if (!ExpandableTextArea) {
            ExpandableTextArea = dynamic_default()(function() {
                return Promise.all(/* import() */[__webpack_require__.e(375), __webpack_require__.e(7229), __webpack_require__.e(6310), __webpack_require__.e(8764), __webpack_require__.e(2074), __webpack_require__.e(3534), __webpack_require__.e(294), __webpack_require__.e(2442)]).then(__webpack_require__.bind(__webpack_require__, 52655));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(52655)
                        ];
                    }
                },
                loading: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                        accessibilityLabel: t("common-loading", "Loading")
                    });
                }
            });
        }
        if (!MentionsTextArea) {
            MentionsTextArea = dynamic_default()(function() {
                return Promise.all(/* import() */[__webpack_require__.e(5290), __webpack_require__.e(9076), __webpack_require__.e(3852)]).then(__webpack_require__.bind(__webpack_require__, 93852));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(93852)
                        ];
                    }
                },
                loading: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                        accessibilityLabel: t("common-loading", "Loading")
                    });
                }
            });
        }
        if (commentId && !CommentListSingular) {
            CommentListSingular = dynamic_default()(function() {
                return Promise.all(/* import() */[__webpack_require__.e(375), __webpack_require__.e(7229), __webpack_require__.e(6310), __webpack_require__.e(8764), __webpack_require__.e(5290), __webpack_require__.e(9076), __webpack_require__.e(2074), __webpack_require__.e(3534), __webpack_require__.e(294), __webpack_require__.e(3852), __webpack_require__.e(2442), __webpack_require__.e(5154), __webpack_require__.e(3173), __webpack_require__.e(5868)]).then(__webpack_require__.bind(__webpack_require__, 95868));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(95868)
                        ];
                    }
                },
                loading: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                        accessibilityLabel: t("common-loading", "Loading")
                    });
                }
            });
        }
        if (!AddCommentModal) {
            AddCommentModal = dynamic_default()(function() {
                return Promise.all(/* import() */[__webpack_require__.e(375), __webpack_require__.e(6310), __webpack_require__.e(8764), __webpack_require__.e(5290), __webpack_require__.e(9076), __webpack_require__.e(3534), __webpack_require__.e(294), __webpack_require__.e(3852), __webpack_require__.e(5461)]).then(__webpack_require__.bind(__webpack_require__, 26635));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(26635)
                        ];
                    }
                },
                loading: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                        accessibilityLabel: t("common-loading", "Loading")
                    });
                }
            });
        }
        if (!CommentList) {
            CommentList = dynamic_default()(function() {
                return Promise.all(/* import() */[__webpack_require__.e(375), __webpack_require__.e(7229), __webpack_require__.e(6310), __webpack_require__.e(8764), __webpack_require__.e(5290), __webpack_require__.e(9076), __webpack_require__.e(2074), __webpack_require__.e(3534), __webpack_require__.e(294), __webpack_require__.e(3852), __webpack_require__.e(2442), __webpack_require__.e(5154), __webpack_require__.e(3173), __webpack_require__.e(478)]).then(__webpack_require__.bind(__webpack_require__, 478));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(478)
                        ];
                    }
                },
                loading: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                        accessibilityLabel: t("common-loading", "Loading")
                    });
                }
            });
        }
        if (!AddCommentContainer) {
            AddCommentContainer = dynamic_default()(function() {
                return Promise.all(/* import() */[__webpack_require__.e(5290), __webpack_require__.e(5154)]).then(__webpack_require__.bind(__webpack_require__, 55154));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(55154)
                        ];
                    }
                },
                loading: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                        accessibilityLabel: t("common-loading", "Loading")
                    });
                }
            });
        }
    }
    if (!AttachmentDisplayer) {
        AttachmentDisplayer = dynamic_default()(function() {
            return Promise.all(/* import() */[__webpack_require__.e(6310), __webpack_require__.e(5607)]).then(__webpack_require__.bind(__webpack_require__, 15607));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(15607)
                    ];
                }
            },
            loading: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                    accessibilityLabel: t("common-loading", "Loading")
                });
            }
        });
    }
    var trackPostEvent = function(event) {
        var _obj;
        return trackEvent(event, (_obj = {}, (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.ATTACHMENT */.Ku.ATTACHMENT, firstAttachment === null || firstAttachment === void 0 ? void 0 : firstAttachment.attachmentType), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.PINNED_POST */.Ku.PINNED_POST, !!post.pinnedAt), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_ID */.Ku.POST_ID, (0,rawId/* rawId */.b)(post.id)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_ID_ENCODED */.Ku.POST_ID_ENCODED, post.id), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_TYPE */.Ku.POST_TYPE, constants/* EVENT_POST_TYPES.POST */.Aj.POST), _obj));
    };
    var goToPost = function() {
        router.push({
            pathname: "/[communityId]/post/[postId]",
            query: {
                communityId: community.id,
                postId: post.id,
                canUseBrowserBack: true
            }
        }, "/communities/".concat(community.id, "/post/").concat(post.id)).then(function() {
            return window.scrollTo(0, 0);
        });
    };
    var handleClickOnSpaceBadge = function(event, filter, name) {
        event.preventDefault();
        event.stopPropagation();
        var _obj;
        trackEvent(trackingEvents/* default.SPACE_CLICKED */.ZP.SPACE_CLICKED, (_obj = {}, (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.SPACE_ID */.Ku.SPACE_ID, (0,rawId/* rawId */.b)(filter)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.SPACE_NAME */.Ku.SPACE_NAME, name), _obj));
        (0,routerHelpers/* goToSpaces */.ZY)(router, filter, community.id, true);
    };
    var handleDeletePost = function(event) {
        document.body.style.overflow = "hidden";
        setIsOpen(true);
        if (event) event.stopPropagation();
    };
    var closeModal = function() {
        document.body.style.overflow = "visible";
        setIsOpen(false);
    };
    var handleEditPost = function(event) {
        document.body.style.overflow = "hidden";
        setIsEditModalOpen(true);
        if (event) event.stopPropagation();
    };
    var closeEditPostModal = function() {
        document.body.style.overflow = "visible";
        setIsEditModalOpen(false);
    };
    var handleConfirmDelete = function(mutation) {
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, deletePostData, deletePostError, userErrors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        _ctx.next = 4;
                        return mutation({
                            variables: {
                                id: post.id
                            },
                            refetchQueries: isPostPage ? [] : [
                                "PostList",
                                "CommunitySpace"
                            ],
                            update: function update() {
                                closeModal();
                            }
                        });
                    case 4:
                        ref1 = _ctx.sent;
                        deletePostData = ref1.data;
                        deletePostError = ref1.errors;
                        trackPostEvent(trackingEvents/* default.DELETE_POST */.ZP.DELETE_POST);
                        userErrors = deletePostData === null || deletePostData === void 0 ? void 0 : (ref = deletePostData.deletePost) === null || ref === void 0 ? void 0 : ref.userErrors;
                        if (!(userErrors === null || userErrors === void 0 ? void 0 : userErrors.length) && !(deletePostError === null || deletePostError === void 0 ? void 0 : deletePostError.length)) {
                            toaster_a57afb61.t.notice(t(constants/* SUCCESS_TOAST.DELETE_POST */.Gy.DELETE_POST));
                        } else {
                            (0,toastHelpers/* genericToastAlert */.d9)();
                        }
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        if (isPostPage) {
                            goToPostListPage === null || goToPostListPage === void 0 ? void 0 : goToPostListPage();
                        }
                        _ctx.next = 17;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,toastHelpers/* genericToastAlert */.d9)();
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    14
                ]
            ]);
        }));
    };
    var currentUserIsModerator = (0,userHelpers/* isModerator */.vJ)(currentUser.roles);
    var userCanEditPost = currentUserIsModerator || currentUser.id && currentUser.id === author.id;
    var postRef = react.useRef(null);
    var creationDateTime = (0,dateHelpers/* relativeFormattedDateTime */.f6)(time, currentUser === null || currentUser === void 0 ? void 0 : currentUser.locale, t);
    var renderButtonForMobile = function(openCommentModal, value) {
        var displayValue = (0,mentions/* makeMentionsUserFriendly */.d1)(value);
        var placeholderValue = t("Type @ to mention another member in your comment");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: cx("post-comment", {
                "has-value": !!value
            }),
            type: "button",
            onClick: openCommentModal,
            children: displayValue || placeholderValue
        });
    };
    var onCommentSubmitted = function() {
        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
        if (commentId) {
            goToPost();
        }
    };
    var relevantMentions = author.id !== currentUser.id ? [
        {
            id: author.id,
            avatarUrl: author.avatarUrl,
            display: author.fullName
        }, 
    ] : [];
    var getCommentBox = function(inputProps) {
        if (window.innerWidth > constants/* BREAKPOINT_MD */.GI) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableTextArea, (0,_object_spread/* default */.Z)({
                id: constants/* COMMENT_FORM_ID */.dp,
                label: t("components-post-add_comment", "Add comment..."),
                labelClass: "sr-only",
                mentionsComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(MentionsTextArea, {
                    additionalClassName: additionalClassName,
                    id: constants/* COMMENT_FORM_ID */.dp,
                    isModal: inputProps.isModal,
                    isPostForm: inputProps.isPostForm,
                    placeholder: t("Type @ to mention another member in your comment"),
                    relevantMentions: relevantMentions,
                    textAreaClassName: "mentions__text-area",
                    value: inputProps.value,
                    onChange: inputProps.handleMentionsChange
                }),
                parentPostRef: postRef,
                s3UploadPath: community.s3UploadPath,
                isAttachmentButtonsEnabled: true,
                isAttachmentRenderedInPortal: true
            }, inputProps));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCommentModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            additionalClassName: "add-comment__modal",
            relevantMentions: relevantMentions
        }, inputProps), {
            renderButton: renderButtonForMobile
        }));
    };
    // eslint-disable-next-line no-shadow
    var commentInput = function(inputProps, currentUser) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: cx("comment-input__wrapper"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                    avatarUrl: currentUser.avatarUrl,
                    className: cx("comment-input__avatar-container"),
                    size: "sm",
                    srcSet: "".concat(currentUser.avatarUrl, "?width=40 1x, ").concat(currentUser.avatarUrl, "?width=40&dpr=2 2x, ").concat(currentUser.avatarUrl, "?width=40&dpr=3 3x"),
                    userId: currentUser.id,
                    username: currentUser.fullName,
                    shouldOpenProfile: true
                }),
                getCommentBox(inputProps)
            ]
        });
    };
    var getCommentSection = function() {
        var commentList;
        if (commentId) {
            commentList = /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentListSingular, {
                commentId: commentId,
                communityWrapperRef: communityWrapperRef,
                lastCommentRef: lastCommentRef,
                parentPostId: post.id,
                parentPostRef: postRef,
                t: t
            });
        } else {
            commentList = /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentList, {
                communityWrapperRef: communityWrapperRef,
                lastCommentRef: lastCommentRef,
                parentPostId: post.id,
                parentPostRef: postRef,
                t: t,
                onPostChange: onPostChange
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: cx("comment-container"),
            children: [
                commentList,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCommentContainer, {
                    communityWrapperRef: communityWrapperRef,
                    lastCommentRef: lastCommentRef,
                    parentPostId: post.id,
                    renderChildren: commentInput,
                    t: t,
                    onCommentSubmitted: onCommentSubmitted
                })
            ]
        });
    };
    var renderEditPostModal = function() {
        if (!EditPostModal) {
            EditPostModal = dynamic_default()(function() {
                return Promise.all(/* import() */[__webpack_require__.e(375), __webpack_require__.e(7229), __webpack_require__.e(1854), __webpack_require__.e(6310), __webpack_require__.e(8764), __webpack_require__.e(5290), __webpack_require__.e(9076), __webpack_require__.e(3760), __webpack_require__.e(2074), __webpack_require__.e(4739), __webpack_require__.e(3534), __webpack_require__.e(294), __webpack_require__.e(3852), __webpack_require__.e(2442), __webpack_require__.e(1475), __webpack_require__.e(9386)]).then(__webpack_require__.bind(__webpack_require__, 40841));
            }, {
                loadableGenerated: {
                    webpack: function() {
                        return [
                            /*require.resolve*/(40841)
                        ];
                    }
                },
                loading: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {
                        accessibilityLabel: t("common-loading", "Loading")
                    });
                }
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EditPostModal, {
            closeModal: closeEditPostModal,
            communityId: community.id,
            content: content,
            hasAutoFocus: isMobile,
            post: post,
            primaryColor: community.primaryColor,
            s3UploadPath: community.s3UploadPath,
            trackEvent: trackEvent
        });
    };
    var renderConfirmDeleteModal = function(mutate, loading) {
        var ConfirmDeleteModal = dynamic_default()(function() {
            return __webpack_require__.e(/* import() */ 6498).then(__webpack_require__.bind(__webpack_require__, 6498));
        }, {
            loadableGenerated: {
                webpack: function() {
                    return [
                        /*require.resolve*/(6498)
                    ];
                }
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDeleteModal, {
                closeAction: closeModal,
                confirmDeleteBody: t("components-post-confirm_delete_post", "Are you sure you want to delete this post? You cannot undo this action."),
                confirmDeleteTitle: t("Delete post"),
                deleteAction: handleConfirmDelete(mutate),
                isConfirmModalOpen: isOpen,
                isLoading: loading
            })
        });
    };
    var commentList = isPostPage && getCommentSection();
    var postActionsList = [];
    if (!isPostPage) {
        if (post.isFollowing && !unfollowLoading) {
            postActionsList.push({
                name: "unfollow",
                text: "".concat(t("Unfollow")),
                onClick: function() {
                    unfollowPost({
                        variables: {
                            id: post.id,
                            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                        }
                    }).then(function() {
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        trackPostEvent(trackingEvents/* default.UNFOLLOW */.ZP.UNFOLLOW);
                    });
                }
            });
        } else if (!followLoading) {
            postActionsList.push({
                name: "follow",
                text: t("Follow"),
                onClick: function() {
                    followPost({
                        variables: {
                            id: post.id,
                            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                        }
                    }).then(function() {
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        trackPostEvent(trackingEvents/* default.FOLLOW */.ZP.FOLLOW);
                    });
                }
            });
        }
    }
    if (userCanEditPost) {
        postActionsList.push({
            name: "edit",
            text: t("common-edit", "Edit"),
            onClick: handleEditPost
        });
    }
    if (currentUserIsModerator) {
        if (post.pinnedAt && !unpinLoading) {
            postActionsList.push({
                name: "unpin",
                text: t("Unpin"),
                onClick: function() {
                    return unpinPost({
                        variables: {
                            id: post.id,
                            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                        }
                    }).then(function() {
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        trackPostEvent(trackingEvents/* default.UNPIN */.ZP.UNPIN);
                        refetchPostList === null || refetchPostList === void 0 ? void 0 : refetchPostList({
                            shouldShowLoading: true
                        });
                    });
                }
            });
        } else if (!pinLoading) {
            postActionsList.push({
                name: "pin",
                text: t("Pin"),
                onClick: function() {
                    return pinPost({
                        variables: {
                            id: post.id,
                            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                        }
                    }).then(function() {
                        onPostChange === null || onPostChange === void 0 ? void 0 : onPostChange();
                        trackPostEvent(trackingEvents/* default.PIN */.ZP.PIN);
                        refetchPostList === null || refetchPostList === void 0 ? void 0 : refetchPostList({
                            shouldShowLoading: true
                        });
                    });
                }
            });
        }
        postActionsList.push({
            name: "delete",
            text: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("post__detail-action"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        className: cx("post__detail-action__icon"),
                        name: "trash-can"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("Delete post")
                    })
                ]
            }),
            title: t("Delete post"),
            onClick: handleDeletePost,
            type: InlineActions_constants/* DANGER_TYPE */.Z
        });
    }
    var hasAttachment = post.postAttachments && post.postAttachments[0];
    var reactionButtonContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactionButton/* default */.Z, {
        hasReacted: post.hasReacted,
        id: post.id,
        isReactingTo: "post",
        postReactionCount: postReactionCount,
        reactionType: constants/* REACTION_TYPES.LIKE_POST */.B0.LIKE_POST,
        reactors: (0,reactionHelpers/* getReactors */.U)(post),
        t: t
    });
    var getAttachmentDisplayer = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachmentDisplayer, {
            attachment: firstAttachment,
            isPostPage: isPostPage,
            t: t
        });
    };
    var getPostContent = function() {
        var handleExpandCollapse = function(e) {
            if (!shouldClampContent && !isPostPage) {
                var ref;
                window.scrollTo(0, ((ref = postRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) || 0);
            }
            e.preventDefault();
            e.stopPropagation();
            setShouldClampContent(!shouldClampContent);
        };
        var readContentButton = content.length > 480 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
            appearance: "accessible-link",
            className: cx("post__content--button"),
            "data-qa": "read-post__button",
            onClick: handleExpandCollapse,
            children: shouldClampContent ? t("Read more") : t("Read less")
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: cx("post__content", hasAttachment ? "post__content--attachment" : ""),
            "data-qa": "post__content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("post__content__text", shouldClampContent ? "post__content__text--clamped" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightContainer/* default */.Z, {
                        content: content,
                        mentionedUsers: mentionedUsers
                    })
                }),
                readContentButton,
                hasAttachment && getAttachmentDisplayer()
            ]
        });
    };
    var postContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("post__detail", {
            "is-spaces-enabled": shouldShowTagOnPost
        }),
        id: post.id,
        role: "article",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("post__body", {
                    "is-spaces-enabled": shouldShowTagOnPost
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cx("post__detail-header", {
                            "is-following": !isPostPage && post.isFollowing
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDetail/* default */.Z, {
                                author: author,
                                editedAt: post.editedAt,
                                time: creationDateTime || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: cx("post__detail-actions"),
                                children: [
                                    !isPostPage && post.isFollowing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Caption */.Y, {
                                        className: cx("post__detail-actions__follow-tag"),
                                        children: t("Following")
                                    }),
                                    post.pinnedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        ariaLabel: t("This post is pinned to the top of the list"),
                                        className: cx("post__detail-actions__pin-icon"),
                                        name: "pin"
                                    }),
                                    postActionsList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostActions/* default */.Z, {
                                        actionsList: postActionsList,
                                        isMobile: isMobile,
                                        t: t
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H1, {
                        className: cx("post__title"),
                        "data-qa": "main-post-title__text",
                        children: post.title
                    }),
                    getPostContent()
                ]
            }),
            !isPostPage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("post__footer", {
                    "is-spaces-enabled": shouldShowTagOnPost
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            reactionButtonContent,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* ButtonWithIconLeft */.ej, {
                                appearance: "knockout",
                                "data-qa": "main-comments_text",
                                size: "small",
                                onClick: goToPost,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        name: "discussions"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("{{count}} comment", {
                                            count: totalCommentCount
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    shouldShowTagOnPost && post.communitySpace && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        "aria-label": t("Go to {{space}}", {
                            space: (ref1 = post.communitySpace) === null || ref1 === void 0 ? void 0 : ref1.name
                        }),
                        className: cx("post__space"),
                        "data-qa": "space-badge-link",
                        href: "/communities/".concat(community.id, "/spaces/").concat((ref2 = post.communitySpace) === null || ref2 === void 0 ? void 0 : ref2.id),
                        title: ((ref3 = post.communitySpace) === null || ref3 === void 0 ? void 0 : ref3.name) || "",
                        onClick: function(event) {
                            var ref, ref1;
                            return handleClickOnSpaceBadge(event, (ref = post.communitySpace) === null || ref === void 0 ? void 0 : ref.id, (ref1 = post.communitySpace) === null || ref1 === void 0 ? void 0 : ref1.name);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                className: cx("post__space__icon"),
                                "data-qa": "post__space__icon",
                                name: (0,spaceHelpers/* getIconNameByStoredValue */.i)(((ref4 = post.communitySpace) === null || ref4 === void 0 ? void 0 : ref4.iconName) || "")
                            }),
                            (ref5 = post.communitySpace) === null || ref5 === void 0 ? void 0 : ref5.name
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("post__info"),
                children: [
                    reactionButtonContent,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cx("total-comments"),
                        "data-qa": "main-comments_text",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                name: "discussions"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("{{count}} comment", {
                                    count: totalCommentCount
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: cx("post__separator")
                    })
                ]
            }),
            commentList
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("post"),
        children: [
            isPostPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx("post__container", "post__container--full"),
                ref: postRef,
                children: postContent
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-label": "".concat(t("Read full post"), ": ").concat(post.title),
                className: cx("post__container"),
                ref: postRef,
                role: "button",
                tabIndex: 0,
                onClick: goToPost,
                onKeyPress: function(e) {
                    if (e.key !== "Enter" && e.key !== " ") {
                        goToPost();
                    }
                },
                children: postContent
            }),
            isEditModalOpen && renderEditPostModal(),
            currentUserIsModerator && isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Mutation/* Mutation */.m, {
                mutation: mutations/* DELETE_POST_MUTATION */.cz,
                children: function(mutate, param) {
                    var loading = param.loading;
                    return renderConfirmDeleteModal(mutate, loading);
                }
            })
        ]
    });
};
/* harmony default export */ var Post_Post = (Post);

;// CONCATENATED MODULE: ./components/Post/index.ts



/***/ }),

/***/ 29035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PostActions_PostActions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./koba/components/Dropdown/constants.ts
var constants = __webpack_require__(43989);
// EXTERNAL MODULE: ./koba/components/InlineActions/constants.js
var InlineActions_constants = __webpack_require__(98939);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Dropdown/index.ts + 9 modules
var Dropdown = __webpack_require__(46744);
// EXTERNAL MODULE: ./koba/components/InlineActions/InlineActions.module.scss
var InlineActions_module = __webpack_require__(4861);
var InlineActions_module_default = /*#__PURE__*/__webpack_require__.n(InlineActions_module);
;// CONCATENATED MODULE: ./koba/components/InlineActions/InlineActions.js
















var cx = bind_default().bind((InlineActions_module_default()));
var InlineActions = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(InlineActions, Component);
    var _super = (0,_create_super/* default */.Z)(InlineActions);
    function InlineActions(props) {
        (0,_class_call_check/* default */.Z)(this, InlineActions);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onHoverHandler", function(hasFocus) {
            return function(e) {
                e.stopPropagation();
                _this.setState({
                    hasFocus: hasFocus
                });
            };
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onMenuItemClick", function(onClickHandler) {
            return function(e) {
                e.stopPropagation();
                _this.setState({
                    isOpen: false
                });
                onClickHandler();
            };
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onToggleHandler", function(open) {
            _this.setState({
                isOpen: open
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "getMainAction", function() {
            var actions = _this.props.actions;
            return actions.filter(function(action) {
                return action.asButton;
            });
        });
        _this.onHoverHandler = _this.onHoverHandler.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onMenuItemClick = _this.onMenuItemClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onToggleHandler = _this.onToggleHandler.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            hasFocus: props.hasFocus,
            isOpen: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(InlineActions, [
        {
            // eslint-disable-next-line camelcase
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var hasFocus = nextProps.hasFocus;
                this.setState({
                    hasFocus: hasFocus
                });
            }
        },
        {
            key: "renderActions",
            value: function renderActions() {
                var _this = this;
                var _props = this.props, buttonAppearance = _props.buttonAppearance, forceMainActionOpen = _props.forceMainActionOpen, ariaLabel = _props.ariaLabel;
                var _state = this.state, hasFocus = _state.hasFocus, isOpen = _state.isOpen;
                var actionClasses = cx("action-button", {
                    active: forceMainActionOpen || hasFocus || isOpen
                });
                return this.getMainAction().map(function(action) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        appearance: buttonAppearance,
                        ariaLabel: ariaLabel,
                        className: actionClasses,
                        onBlur: _this.onHoverHandler(false),
                        onClick: action.onClick,
                        onFocus: _this.onHoverHandler(true),
                        onMouseOut: _this.onHoverHandler(false),
                        onMouseOver: _this.onHoverHandler(true),
                        children: action.name
                    }, action.name);
                });
            }
        },
        {
            key: "renderMoreActions",
            value: function renderMoreActions() {
                var _this = this;
                var _props = this.props, ariaLabel = _props.ariaLabel, buttonAppearance = _props.buttonAppearance, icon = _props.icon, actions = _props.actions, alignment = _props.alignment, forceMainActionOpen = _props.forceMainActionOpen, isCompactMode = _props.isCompactMode, dimensions = _props.dimensions;
                var _state = this.state, hasFocus = _state.hasFocus, isOpen = _state.isOpen;
                var isActionActive = forceMainActionOpen || hasFocus || isOpen;
                var deleteActions = actions.filter(function(action) {
                    return action.type === InlineActions_constants/* DANGER_TYPE */.Z;
                });
                var nonSpecializedActions = actions.filter(function(action) {
                    return !action.asButton && action.type !== InlineActions_constants/* DANGER_TYPE */.Z;
                });
                var hasMainAction = this.getMainAction().length > 0;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("ellipsis-button"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.Lt, {
                        toggleListener: this.onToggleHandler,
                        children: function(param) {
                            var open = param.open, toggleMenu = param.toggleMenu;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                        appearance: buttonAppearance,
                                        ariaLabel: ariaLabel,
                                        className: cx("inline-actions--toggle", {
                                            "inline-actions--active-toggle": isActionActive,
                                            "button--default": isActionActive,
                                            "compact-mode": isCompactMode,
                                            "has-main-action": !isCompactMode && hasMainAction
                                        }),
                                        dataQA: "inline-actions__btn",
                                        onClick: toggleMenu,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            name: icon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* Menu */.v2, {
                                        dimensions: dimensions,
                                        open: open,
                                        position: alignment,
                                        children: [
                                            isCompactMode && _this.getMainAction().map(function(action) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                                    title: action.title || action.text,
                                                    onClick: _this.onMenuItemClick(action.onClick),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                        appearance: "knockout",
                                                        className: cx("inline-actions__more-actions--button"),
                                                        children: action.text
                                                    })
                                                }, action.name);
                                            }),
                                            nonSpecializedActions.map(function(action) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                                    className: cx("inline-actions__item"),
                                                    title: action.title || action.text,
                                                    onClick: _this.onMenuItemClick(action.onClick),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                        appearance: "knockout",
                                                        className: cx("inline-actions__more-actions--button"),
                                                        children: action.text
                                                    })
                                                }, action.name);
                                            }),
                                            deleteActions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    nonSpecializedActions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                                        className: cx("inline-actions__separator")
                                                    }),
                                                    deleteActions.map(function(deleteAction) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                                            className: cx("inline-actions__item", "dropdown"),
                                                            title: deleteAction.title || deleteAction.text,
                                                            onClick: deleteAction.onClick,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                                                appearance: "knockout",
                                                                className: cx("inline-actions__more-actions--button", "inline-actions__item--danger"),
                                                                hasDanger: true,
                                                                children: deleteAction.text
                                                            })
                                                        }, deleteAction.name);
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, alignment = _props.alignment, isCompactMode = _props.isCompactMode, wrapperClass = _props.wrapperClass;
                var containerClasses = cx("container", "container-".concat(alignment), wrapperClass);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: containerClasses,
                    children: [
                        alignment === "right" && !isCompactMode && this.renderActions(),
                        this.renderMoreActions(),
                        alignment === "left" && !isCompactMode && this.renderActions()
                    ]
                });
            }
        }
    ]);
    return InlineActions;
}(react.Component);
InlineActions.propTypes = {
    /** Array of the possible actions */ actions: prop_types_default().arrayOf(prop_types_default().shape({
        /** Flag to show as button instead of within toggle menu */ asButton: (prop_types_default()).bool,
        /** Name of action (appears as button text) */ name: (prop_types_default()).string.isRequired,
        /** More detailed text to display for action (appears in action menu) */ text: prop_types_default().oneOfType([
            (prop_types_default()).string,
            (prop_types_default()).node
        ]).isRequired,
        /** Title to be displayed on action hover. Should be passed when text property is a node. */ title: (prop_types_default()).string,
        /** Handler when action is clicked */ onClick: (prop_types_default()).func.isRequired
    })).isRequired,
    /** Alignment of the menu and buttons with the toggle */ alignment: prop_types_default().oneOf([
        "left",
        "right"
    ]),
    /** Button aria-label */ ariaLabel: (prop_types_default()).string,
    /** Button appearance */ buttonAppearance: prop_types_default().oneOf([
        "default",
        "knockout",
        "ghost"
    ]),
    dimensions: constants/* DROPDOWN_DIMENSIONS_PROP_TYPE */.Nh,
    /** For the main action to be shown * */ forceMainActionOpen: (prop_types_default()).bool,
    /** Flag to indicate component is in focus */ hasFocus: (prop_types_default()).bool,
    /** Icon for menu toggle */ icon: (prop_types_default()).string,
    /** Toggles the compact version * */ isCompactMode: (prop_types_default()).bool,
    /** Add classes to the wrapper container * */ wrapperClass: (prop_types_default()).string
};
InlineActions.defaultProps = {
    ariaLabel: null,
    buttonAppearance: "default",
    hasFocus: false,
    icon: "ellipsis-v",
    alignment: "right",
    forceMainActionOpen: false,
    isCompactMode: false,
    wrapperClass: null,
    dimensions: constants/* DROPDOWN_DIMENSIONS_DEFAULT_PROP */.yW
};
/* harmony default export */ var InlineActions_InlineActions = (InlineActions);

;// CONCATENATED MODULE: ./koba/components/InlineActions/index.js



// EXTERNAL MODULE: ./components/ActionModal/index.ts + 2 modules
var ActionModal = __webpack_require__(92994);
// EXTERNAL MODULE: ./components/PostActions/PostActions.module.scss
var PostActions_module = __webpack_require__(70589);
var PostActions_module_default = /*#__PURE__*/__webpack_require__.n(PostActions_module);
;// CONCATENATED MODULE: ./components/PostActions/PostActions.tsx










var PostActions_cx = bind_default().bind((PostActions_module_default()));
var PostActions = function(param) {
    var _actionsList = param.actionsList, actionsList = _actionsList === void 0 ? [] : _actionsList, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, t = param.t;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var openActionsModal = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setIsOpen(true);
    };
    var closeActionsModal = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setIsOpen(false);
    };
    var handleAction = function(action) {
        return function(e) {
            setIsOpen(false);
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            action();
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonWithIconOnly */.Au, {
                    appearance: "knockout",
                    ariaLabel: t("Open/close actions menu"),
                    className: PostActions_cx("post-actions__button"),
                    onClick: openActionsModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        className: PostActions_cx("post-actions__button-icon"),
                        name: "ellipsis-v"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionModal/* ActionModal */.W, {
                    closeModal: closeActionsModal,
                    isOpen: isOpen,
                    t: t,
                    children: actionsList.map(function(action) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionModal/* ActionModalItem */.z, {
                            isDanger: action.type === InlineActions_constants/* DANGER_TYPE */.Z,
                            title: action.title || action.text,
                            onClick: handleAction(action.onClick),
                            children: action.text
                        }, action.name);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineActions_InlineActions, {
            actions: actionsList,
            ariaLabel: t("Open/close actions menu"),
            buttonAppearance: "knockout",
            wrapperClass: PostActions_cx("comment__inline-actions")
        })
    });
};
PostActions.propTypes = {
    actionsList: (prop_types_default()).array,
    isMobile: (prop_types_default()).bool,
    t: (prop_types_default()).func.isRequired
};
PostActions.defaultProps = {
    actionsList: [],
    isMobile: false
};
/* harmony default export */ var PostActions_PostActions = (PostActions);

;// CONCATENATED MODULE: ./components/PostActions/index.ts



/***/ }),

/***/ 44215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ReactionButton_ReactionButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./schema/Replies/mutations.ts
var mutations = __webpack_require__(752);
// EXTERNAL MODULE: ./schema/Post/mutations.ts
var Post_mutations = __webpack_require__(74266);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./helpers/reactionHelpers.ts
var reactionHelpers = __webpack_require__(72579);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
;// CONCATENATED MODULE: ./components/ReactionButton/helpers.ts
var getScreenReaderText = function(hasReacted, reactionCount, isReactingTo, t) {
    switch(isReactingTo){
        case "comment":
            return hasReacted ? "".concat(t("components-reactionButton-remove_heart_from_comment_sr_text", "You reacted with a heart to this comment. Click to remove the reaction."), " ").concat(getTotalNumberOfReactionsString(reactionCount, t)) : "".concat(t("components-reactionButton-react_with_heart_to_comment_sr_text", "You have not reacted to this comment. Click to react with a heart."), " ").concat(getTotalNumberOfReactionsString(reactionCount, t));
        default:
            return hasReacted ? "".concat(t("components-reactionButton-remove_heart_from_post_sr_text", "You reacted with a heart to this post. Click to remove the reaction."), " ").concat(getTotalNumberOfReactionsString(reactionCount, t)) : "".concat(t("components-reactionButton-react_with_heart_to_post_sr_text", "You have not reacted to this post. Click to react with a heart."), " ").concat(getTotalNumberOfReactionsString(reactionCount, t));
    }
};
function getTotalNumberOfReactionsString(reactionCount, t) {
    return t("components-reactionButton-total_reactions_sr_text", "The total number of reactions for this item is {{reactionCount}}.", {
        reactionCount: reactionCount
    });
}

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
;// CONCATENATED MODULE: ./components/ReactionButton/ReactionHoverList.tsx




var ReactionHoverList = function(param) {
    var children = param.children, hasReacted = param.hasReacted, postReactionCount = param.postReactionCount, reactionsToShow = param.reactionsToShow, reactors = param.reactors, t = param.t;
    var currentUser = (0,CommunityContext/* useCommunityContext */.v1)().currentUser;
    var reactorList = reactors.slice();
    var isCurrentUserInList = currentUser && !!reactors.find(function(r) {
        return r.id === currentUser.id;
    });
    if (hasReacted && currentUser) {
        if (isCurrentUserInList) {
            // Need to remove their name and put You at the front
            reactorList = reactorList.filter(function(r) {
                return r.id !== currentUser.id;
            });
            reactorList.unshift({
                fullName: t("You")
            });
        } else {
            // Put You at the front, and pop someone off the back
            reactorList.unshift({
                fullName: t("You")
            });
            if (postReactionCount >= reactionsToShow) {
                reactorList.pop();
            }
        }
    }
    if (postReactionCount > reactionsToShow) {
        var hiddenReactors = postReactionCount - reactionsToShow;
        var plusMore = {
            fullName: t("+ {{nameCount}} more", {
                nameCount: hiddenReactors
            })
        };
        reactorList = reactorList.slice(0, reactionsToShow).concat(plusMore);
    }
    var reactorNames = reactorList.map(function(r) {
        return r.fullName;
    }).join(", ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
        enterDelay: 400,
        title: reactorNames,
        children: children
    });
};
/* harmony default export */ var ReactionButton_ReactionHoverList = (ReactionHoverList);

// EXTERNAL MODULE: ./components/ReactionButton/ReactionButton.module.scss
var ReactionButton_module = __webpack_require__(6950);
var ReactionButton_module_default = /*#__PURE__*/__webpack_require__.n(ReactionButton_module);
;// CONCATENATED MODULE: ./components/ReactionButton/ReactionButton.tsx





















var cx = bind_default().bind((ReactionButton_module_default()));
var ReactionButton = function(param) {
    var _appearance = param.appearance, appearance = _appearance === void 0 ? "knockout" : _appearance, hasReactedProp = param.hasReacted, id = param.id, isReactingTo = param.isReactingTo, _parentPostId = param.parentPostId, parentPostId = _parentPostId === void 0 ? "" : _parentPostId, _parentReplyId = param.parentReplyId, parentReplyId = _parentReplyId === void 0 ? "" : _parentReplyId, postReactionCount = param.postReactionCount, reactionType = param.reactionType, reactors = param.reactors, _size = param.size, size = _size === void 0 ? "small" : _size, t = param.t;
    var trackEvent = (0,CommunityContext/* useCommunityContext */.v1)().trackEvent;
    var ref = (0,react.useState)((0,reactionHelpers/* getIconName */.t)(reactionType, hasReactedProp)), iconName = ref[0], setIconName = ref[1];
    var ref1 = (0,react.useState)(postReactionCount), reactionCount = ref1[0], setReactionCount = ref1[1];
    var ref2 = (0,react.useState)(hasReactedProp), hasReacted = ref2[0], setHasReacted = ref2[1];
    var screenReaderText = getScreenReaderText(!!hasReacted, reactionCount, isReactingTo, t);
    (0,react.useEffect)(function() {
        setIconName((0,reactionHelpers/* getIconName */.t)(reactionType, hasReacted));
    }, [
        reactionType,
        hasReacted
    ]);
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(Post_mutations/* TOGGLE_REACTION_ON_POST_MUTATION */.t3, {
        onError: toastHelpers/* genericToastAlert */.d9
    }), 2), toggleReactionOnPostMutation = ref3[0], ref4 = ref3[1], togglePostReactionLoading = ref4.loading;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* TOGGLE_REACTION_ON_REPLY_MUTATION */.Y3, {
        onError: toastHelpers/* genericToastAlert */.d9
    }), 2), toggleReactionOnReplyMutation = ref5[0], ref6 = ref5[1], toggleReplyReactionLoading = ref6.loading;
    var handleParentPostReactionClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, reactPostData, reactPostError, userErrors, _post, updatedHasReacted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (togglePostReactionLoading) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        _ctx.next = 4;
                        return toggleReactionOnPostMutation({
                            variables: {
                                id: id,
                                reactionType: reactionType,
                                numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                            }
                        });
                    case 4:
                        ref1 = _ctx.sent;
                        reactPostData = ref1.data;
                        reactPostError = ref1.errors;
                        userErrors = reactPostData === null || reactPostData === void 0 ? void 0 : (ref = reactPostData.toggleReactionOnPost) === null || ref === void 0 ? void 0 : ref.userErrors;
                        if (!(userErrors === null || userErrors === void 0 ? void 0 : userErrors.length) && !(reactPostError === null || reactPostError === void 0 ? void 0 : reactPostError.length)) {
                            _post = reactPostData.toggleReactionOnPost.post, updatedHasReacted = _post.hasReacted;
                            trackReactEvent({
                                hasReacted: updatedHasReacted
                            });
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleParentPostReactionClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReplyReactionClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, reactReplyData, reactReplyError, userErrors, _reply, updatedHasReacted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (toggleReplyReactionLoading) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        _ctx.next = 4;
                        return toggleReactionOnReplyMutation({
                            variables: {
                                id: id,
                                reactionType: reactionType,
                                numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
                            }
                        });
                    case 4:
                        ref1 = _ctx.sent;
                        reactReplyData = ref1.data;
                        reactReplyError = ref1.errors;
                        userErrors = reactReplyData === null || reactReplyData === void 0 ? void 0 : (ref = reactReplyData.toggleReactionOnReply) === null || ref === void 0 ? void 0 : ref.userErrors;
                        if (!(userErrors === null || userErrors === void 0 ? void 0 : userErrors.length) && !(reactReplyError === null || reactReplyError === void 0 ? void 0 : reactReplyError.length)) {
                            _reply = reactReplyData.toggleReactionOnReply.reply, updatedHasReacted = _reply.hasReacted;
                            trackReactEvent({
                                hasReacted: updatedHasReacted
                            });
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReplyReactionClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReactionClick = function(e) {
        e.stopPropagation();
        if (togglePostReactionLoading || toggleReplyReactionLoading) return;
        setReactionCount(hasReacted ? reactionCount - 1 : reactionCount + 1);
        setHasReacted(!hasReacted);
        if (!parentPostId && !parentReplyId) {
            handleParentPostReactionClick();
        } else {
            handleReplyReactionClick();
        }
    };
    var trackReactEvent = function(updatedInfo) {
        var postType = parentReplyId ? constants/* EVENT_POST_TYPES.REPLY */.Aj.REPLY : constants/* EVENT_POST_TYPES.COMMENT */.Aj.COMMENT;
        postType = parentPostId ? postType : constants/* EVENT_POST_TYPES.POST */.Aj.POST;
        var reactedAt = new Date();
        var _obj;
        trackEvent(trackingEvents/* default.POST_REACTED */.ZP.POST_REACTED, (_obj = {}, (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_ID */.Ku.POST_ID, (0,rawId/* rawId */.b)(id)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_ID_ENCODED */.Ku.POST_ID_ENCODED, id), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.POST_TYPE */.Ku.POST_TYPE, postType), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.INTERACTION_TYPE */.Ku.INTERACTION_TYPE, updatedInfo.hasReacted ? "Added Reaction" : "Removed Reaction"), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.REACTION_TIMESTAMP */.Ku.REACTION_TIMESTAMP, reactedAt.toISOString()), _obj));
    };
    var reactionButton = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* ButtonWithIconLeft */.ej, {
        appearance: appearance,
        className: parentPostId ? cx("comment__reaction-button") : "",
        "data-qa": "reaction-button",
        size: size,
        onClick: handleReactionClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                name: iconName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "aria-live": "polite",
                className: cx("sr-only"),
                children: screenReaderText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "aria-hidden": true,
                children: reactionCount
            })
        ]
    });
    var isLoading = togglePostReactionLoading || toggleReplyReactionLoading;
    if (reactors && reactionCount && !isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactionButton_ReactionHoverList, {
            hasReacted: !!hasReacted,
            postReactionCount: reactionCount,
            reactionsToShow: constants/* NUMBER_OF_REACTIONS */.ed,
            reactors: reactors,
            t: t,
            children: reactionButton
        });
    }
    return reactionButton;
};
/* harmony default export */ var ReactionButton_ReactionButton = (ReactionButton);

;// CONCATENATED MODULE: ./components/ReactionButton/index.ts



/***/ }),

/***/ 50826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UserDetail_UserDetail; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(1798);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/ModeratorBadge/index.ts + 1 modules
var ModeratorBadge = __webpack_require__(45475);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/UserDetail/UserDetail.module.scss
var UserDetail_module = __webpack_require__(88968);
var UserDetail_module_default = /*#__PURE__*/__webpack_require__.n(UserDetail_module);
;// CONCATENATED MODULE: ./components/UserDetail/UserDetail.tsx















var cx = bind_default().bind((UserDetail_module_default()));
var UserDetail = function(param) {
    var author = param.author, editedAt = param.editedAt, time = param.time, isEditing = param.isEditing, isReply = param.isReply, _totalReplyCount = param.totalReplyCount, totalReplyCount = _totalReplyCount === void 0 ? 0 : _totalReplyCount, isFollowing = param.isFollowing;
    var userDetailRef = (0,react.useRef)(null);
    var t = (0,es/* useTranslation */.$G)().t;
    var trackEvent = (0,CommunityContext/* useCommunityContext */.v1)().trackEvent;
    var isAuthorModerator = (0,userHelpers/* isModerator */.vJ)(author.roles);
    var profileAriaLabel = t("components-userDetail-posted_by_aria_label", "Posted by {{fullName}} {{moderator}} {{time}}. Press enter or space to open profile panel", {
        fullName: author.fullName,
        time: time,
        moderator: isAuthorModerator ? t("Moderator") : ""
    });
    var handleUserDetailAction = function(event) {
        if (event.key === "Enter" || event.key === " " || event.type === "click") {
            event.preventDefault();
            event.stopPropagation();
            pubsub_default().publish(eventNames/* eventNames.OPEN_PROFILE_PANEL */.S.OPEN_PROFILE_PANEL, {
                userId: author.id,
                lastElementRef: userDetailRef
            });
            trackEvent(trackingEvents/* default.PROFILE_PANEL_TAB_OPENED */.ZP.PROFILE_PANEL_TAB_OPENED, {});
        }
    };
    var extraProps = {
        role: "button",
        "aria-label": profileAriaLabel,
        tabIndex: 0,
        onClick: handleUserDetailAction,
        onKeyDown: handleUserDetailAction,
        ref: userDetailRef
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: cx("user-detail", {
            "user-detail__edit": isEditing,
            "user-detail__reply": isReply
        }),
        "data-qa": "user-detail"
    }, extraProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx("user-detail__wrapper"),
                "data-qa": "user-detail__wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                    avatarUrl: author.avatarUrl,
                    className: cx("user-detail__avatar"),
                    size: "sm",
                    srcSet: "".concat(author.avatarUrl, "?width=40 1x, ").concat(author.avatarUrl, "?width=40&dpr=2 2x, ").concat(author.avatarUrl, "?width=40&dpr=3 3x"),
                    userId: author.id,
                    username: author.fullName || ""
                })
            }),
            !isEditing && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cx("user-detail__name-moderator"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.P, {
                                className: cx("user-detail__name"),
                                "data-qa": "main-user-detail-name__link",
                                title: author.fullName || "",
                                children: author.fullName
                            }),
                            isAuthorModerator && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeratorBadge/* default */.Z, {
                                className: cx("user-detail__moderator-badge"),
                                children: t("common-MODERATOR", "MODERATOR")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography.P, {
                        className: cx("user-detail__label"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("user-detail__time"),
                                children: time
                            }),
                            editedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("user-detail__edited"),
                                children: t("Edited")
                            }),
                            totalReplyCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("user-detail__total-replies"),
                                children: t("{{count}} reply", {
                                    count: totalReplyCount
                                })
                            }),
                            !isReply && isFollowing && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("user-detail__following"),
                                children: t("Following")
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var UserDetail_UserDetail = (UserDetail);

;// CONCATENATED MODULE: ./components/UserDetail/index.ts



/***/ }),

/***/ 72579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getReactors; },
/* harmony export */   "t": function() { return /* binding */ getIconName; }
/* harmony export */ });
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59830);

function getIconName() {
    var reactionType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_TYPES.LIKE_POST */ .B0.LIKE_POST, hasReacted = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    switch(reactionType){
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_TYPES.LIKE_POST */ .B0.LIKE_POST:
            return hasReacted ? utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_ICONS.LIKE_POST_TRUE */ .iS.LIKE_POST_TRUE : utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_ICONS.LIKE_POST_FALSE */ .iS.LIKE_POST_FALSE;
        default:
            return utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .REACTION_ICONS.LIKE_POST_FALSE */ .iS.LIKE_POST_FALSE;
    }
}
var getReactors = function(post) {
    var edges = post && post.postReactions && post.postReactions.edges;
    var usersWithNames = edges === null || edges === void 0 ? void 0 : edges.filter(function(edge) {
        var ref;
        var user = edge === null || edge === void 0 ? void 0 : (ref = edge.node) === null || ref === void 0 ? void 0 : ref.user;
        return (user === null || user === void 0 ? void 0 : user.id) != null && (user === null || user === void 0 ? void 0 : user.fullName) != null;
    });
    return Array.isArray(usersWithNames) ? usersWithNames.map(function(edge) {
        var ref;
        var user = edge === null || edge === void 0 ? void 0 : (ref = edge.node) === null || ref === void 0 ? void 0 : ref.user;
        return {
            id: (user === null || user === void 0 ? void 0 : user.id) || "",
            fullName: (user === null || user === void 0 ? void 0 : user.fullName) || ""
        };
    }) : [];
};


/***/ }),

/***/ 98939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DANGER_TYPE; }
/* harmony export */ });
// eslint-disable-next-line import/prefer-default-export
var DANGER_TYPE = "danger";


/***/ }),

/***/ 94000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35330);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_3___default().bind((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var ModalBody = function(_param) /*#__PURE__*/ {
    var children = _param.children, isFullWidth = _param.isFullWidth, hasTitle = _param.hasTitle, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "isFullWidth",
        "hasTitle"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: cx("modal__body", {
            "no-padding": isFullWidth,
            "no-title": !hasTitle
        })
    }, rest), {
        children: children
    }));
};
ModalBody.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired),
    hasTitle: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
    isFullWidth: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
ModalBody.defaultProps = {
    isFullWidth: false,
    hasTitle: false
};
ModalBody.displayName = "ModalBody";
/* harmony default export */ __webpack_exports__["Z"] = (ModalBody);


/***/ }),

/***/ 21838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35330);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_3___default().bind((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var ModalFooter = function(_param) /*#__PURE__*/ {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: cx("modal__footer")
    }, rest), {
        children: children
    }));
};
ModalFooter.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired)
};
ModalFooter.displayName = "ModalFooter";
/* harmony default export */ __webpack_exports__["Z"] = (ModalFooter);


/***/ }),

/***/ 70394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35330);
/* harmony import */ var _Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_3___default().bind((_Modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var ModalHeader = function(_param) /*#__PURE__*/ {
    var children = _param.children, className = _param.className, hasTitle = _param.hasTitle, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "hasTitle"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: cx("modal__header", className)
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: cx({
                "has-title": hasTitle
            }),
            children: children
        })
    }));
};
ModalHeader.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired),
    className: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array),
        (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), 
    ]),
    hasTitle: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
ModalHeader.defaultProps = {
    className: null,
    hasTitle: false
};
ModalHeader.displayName = "ModalHeader";
/* harmony default export */ __webpack_exports__["Z"] = (ModalHeader);


/***/ }),

/***/ 97971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Modal_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Modal/ModalBody/ModalBody.js
var ModalBody = __webpack_require__(94000);
// EXTERNAL MODULE: ./koba/components/Modal/ModalFooter/ModalFooter.js
var ModalFooter = __webpack_require__(21838);
// EXTERNAL MODULE: ./koba/components/Modal/ModalHeader/ModalHeader.js
var ModalHeader = __webpack_require__(70394);
// EXTERNAL MODULE: ./koba/components/Modal/Modal.module.scss
var Modal_module = __webpack_require__(35330);
var Modal_module_default = /*#__PURE__*/__webpack_require__.n(Modal_module);
;// CONCATENATED MODULE: ./koba/components/Modal/Modal.js












var cx = bind_default().bind((Modal_module_default()));
var findComponent = function(children, componentToFind) {
    return react.Children.toArray(children).find(function(component) {
        return component.type && component.type.displayName === componentToFind;
    });
};
var Modal = function(param) {
    var modalBodyClasses = param.modalBodyClasses, children = param.children, contentLabel = param.contentLabel, closeModal = param.closeModal, isOpen = param.isOpen, title = param.title, footer = param.footer, isFullWidth = param.isFullWidth, dataQA = param.dataQA;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((lib_default()), {
        ariaHideApp: false,
        className: cx("modal", modalBodyClasses),
        contentLabel: contentLabel,
        data: {
            qa: dataQA
        },
        isOpen: isOpen,
        overlayClassName: cx("overlay"),
        onRequestClose: closeModal,
        children: [
            findComponent(children, "ModalHeader"),
            title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader/* default */.Z, {
                hasTitle: !!title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H1, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        appearance: "knockout",
                        "aria-label": "Close modal",
                        className: cx("modal__header__close-button"),
                        onClick: closeModal,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "x-dismiss"
                        })
                    })
                ]
            }),
            findComponent(children, "ModalBody") || /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody/* default */.Z, {
                hasTitle: !!title,
                isFullWidth: isFullWidth,
                children: children
            }),
            findComponent(children, "ModalFooter"),
            footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooter/* default */.Z, {
                children: footer
            })
        ]
    });
};
Modal.propTypes = {
    children: (prop_types_default()).node.isRequired,
    closeModal: (prop_types_default()).func.isRequired,
    contentLabel: (prop_types_default()).string,
    dataQA: (prop_types_default()).string,
    footer: (prop_types_default()).node,
    isFullWidth: (prop_types_default()).bool,
    isOpen: (prop_types_default()).bool.isRequired,
    modalBodyClasses: prop_types_default().oneOfType([
        (prop_types_default()).array,
        (prop_types_default()).string,
        (prop_types_default()).object, 
    ]),
    title: (prop_types_default()).node
};
Modal.defaultProps = {
    dataQA: null,
    modalBodyClasses: null,
    title: null,
    contentLabel: "Modal",
    footer: null,
    isFullWidth: false
};
/* harmony default export */ var Modal_Modal = (Modal);

;// CONCATENATED MODULE: ./koba/components/Modal/index.js



/***/ }),

/***/ 74266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hd": function() { return /* binding */ EDIT_POST_MUTATION; },
/* harmony export */   "JB": function() { return /* binding */ UNFOLLOW_POST_MUTATION; },
/* harmony export */   "Nw": function() { return /* binding */ UNPIN_POST_MUTATION; },
/* harmony export */   "O7": function() { return /* binding */ PIN_POST_MUTATION; },
/* harmony export */   "ZH": function() { return /* binding */ FOLLOW_POST_MUTATION; },
/* harmony export */   "cz": function() { return /* binding */ DELETE_POST_MUTATION; },
/* harmony export */   "dl": function() { return /* binding */ CREATE_POST_MUTATION; },
/* harmony export */   "t3": function() { return /* binding */ TOGGLE_REACTION_ON_POST_MUTATION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81849);
/* harmony import */ var utils_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57917);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreatePost(\n    $discussionableId: ID!\n    $title: String!\n    $content: String\n    $spaceId: ID\n    $postAttachment: PostAttachmentInput\n    $mentionedUserIds: [ID!]\n  ) {\n    createPost(\n      input: {\n        discussionableId: $discussionableId\n        title: $title\n        content: $content\n        communitySpaceId: $spaceId\n        postAttachmentInput: $postAttachment\n        mentionedUserIds: $mentionedUserIds\n      }\n    ) {\n      post {\n        id\n      }\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation EditPost($input: EditPostInput!, $numberOfReactions: Int!) {\n    editPost(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeletePost($id: ID!) {\n    deletePost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation FollowPost($id: ID!, $numberOfReactions: Int!) {\n    followPost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UnfollowPost($id: ID!, $numberOfReactions: Int!) {\n    unfollowPost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation PinPost($id: ID!, $numberOfReactions: Int!) {\n    pinPost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UnpinPost($id: ID!, $numberOfReactions: Int!) {\n    unpinPost(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleReactionOnPost(\n    $id: ID!\n    $reactionType: PostReactionType!\n    $numberOfReactions: Int!\n  ) {\n    toggleReactionOnPost(input: { id: $id, reactionType: $reactionType }) {\n      userErrors {\n        code\n        message\n      }\n      post {\n        ...PostFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var CREATE_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject());
var EDIT_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var DELETE_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var FOLLOW_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var UNFOLLOW_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject4(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var PIN_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject5(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var UNPIN_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject6(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);
var TOGGLE_REACTION_ON_POST_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject7(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT */ .Tj);


/***/ }),

/***/ 752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jx": function() { return /* binding */ FOLLOW_REPLY_MUTATION; },
/* harmony export */   "WQ": function() { return /* binding */ UNFOLLOW_REPLY_MUTATION; },
/* harmony export */   "WR": function() { return /* binding */ DELETE_REPLY_MUTATION; },
/* harmony export */   "Y3": function() { return /* binding */ TOGGLE_REACTION_ON_REPLY_MUTATION; },
/* harmony export */   "jn": function() { return /* binding */ EDIT_REPLY_MUTATION; },
/* harmony export */   "o4": function() { return /* binding */ CREATE_REPLY_MUTATION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81849);
/* harmony import */ var _utils_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57917);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateReply(\n    $discussionableId: ID!\n    $content: String\n    $parentPostId: ID\n    $parentReplyId: ID\n    $postAttachmentInput: PostAttachmentInput\n    $mentionedUserIds: [ID!]\n    $numberOfReactions: Int!\n  ) {\n    createReply(\n      input: {\n        discussionableId: $discussionableId\n        content: $content\n        parentPostId: $parentPostId\n        parentReplyId: $parentReplyId\n        postAttachmentInput: $postAttachmentInput\n        mentionedUserIds: $mentionedUserIds\n      }\n    ) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation EditReply($input: EditReplyInput!, $numberOfReactions: Int!) {\n    editReply(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeleteReply($id: ID!) {\n    deleteReply(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleReactionOnReply(\n    $id: ID!\n    $reactionType: PostReactionType!\n    $numberOfReactions: Int!\n  ) {\n    toggleReactionOnReply(input: { id: $id, reactionType: $reactionType }) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation FollowReply($id: ID!, $numberOfReactions: Int!) {\n    followReply(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UnfollowReply($id: ID!, $numberOfReactions: Int!) {\n    unfollowReply(input: { id: $id }) {\n      userErrors {\n        code\n        message\n      }\n      reply {\n        ...ReplyFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var CREATE_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);
var EDIT_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);
var DELETE_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject2());
var TOGGLE_REACTION_ON_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject3(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);
var FOLLOW_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject4(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);
var UNFOLLOW_REPLY_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject5(), _utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .REPLY_FRAGMENT */ .sN);


/***/ }),

/***/ 29296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q0": function() { return /* binding */ insertEmoji; },
/* harmony export */   "d1": function() { return /* binding */ makeMentionsUserFriendly; },
/* harmony export */   "gI": function() { return /* binding */ displayTransform; },
/* harmony export */   "gj": function() { return /* binding */ markupPattern; },
/* harmony export */   "yq": function() { return /* binding */ replaceMentions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _regex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14255);
/* harmony import */ var _textHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51661);



var markupPattern = "@[__display__](__id__)";
var displayTransform = function(_id, display) {
    return "@".concat(display);
};
/*
  Update user names in a block of text with their current name
 */ var replaceMentions = function(text, mentionedUsers) {
    var ref;
    var result = text || "";
    mentionedUsers === null || mentionedUsers === void 0 ? void 0 : (ref = mentionedUsers.edges) === null || ref === void 0 ? void 0 : ref.forEach(function(edge) {
        var node = edge === null || edge === void 0 ? void 0 : edge.node;
        if ((node === null || node === void 0 ? void 0 : node.id) && (node === null || node === void 0 ? void 0 : node.fullName)) {
            result = result.replace((0,_regex__WEBPACK_IMPORTED_MODULE_0__/* .mentionIdRegex */ .YA)(node.id), function() {
                return "@[".concat(node.fullName, "](").concat(node.id, ")");
            });
        }
    });
    return result;
};
var makeMentionsUserFriendly = function(text) {
    var result = text || "";
    if (result) {
        result = result.replace(_regex__WEBPACK_IMPORTED_MODULE_0__/* .MENTION_REGEX_GLOBAL */ .Vo, "@$1");
    }
    return result;
};
/*
  A super maintainable function that can insert emojis into react-mentions text. My sincerest apologies to the
  next person that needs to make a change to this.
  It requires that markupPattern equal @[__display__](__id__) and displayTransform returns @${display}
 */ var insertEmoji = function(emoji, position, value, content) {
    if (!emoji) return content || "";
    if (position === null || position > (value === null || value === void 0 ? void 0 : value.length)) return content;
    var currentContent = content;
    var isRestrictedPosition = false;
    var shiftRight = 0;
    var restrictedRanges = [];
    if (value !== content) {
        // If the textarea and the react-mentions content are different, it means mentions have been added
        for(var i = 0; i < position; i += 1){
            var currentChar = value[i];
            var currentContentChar = currentContent[i + shiftRight];
            var nextContentChar = currentContent[i + shiftRight + 1];
            if (currentChar === "@" && currentContentChar === "@" && nextContentChar === "[") {
                var indexOfNextClosingBracket = currentContent.indexOf("]", shiftRight + i + 2);
                if (indexOfNextClosingBracket > -1) {
                    var name = currentContent.substring(i + shiftRight + 2, indexOfNextClosingBracket);
                    if (value.indexOf(name, i + 1) === i + 1) {
                        // we know the next set of characters is the name portion of a mention
                        if (currentContent[indexOfNextClosingBracket + 1] === "(") {
                            // We are at the start of the id portion of a mention
                            var indexOfFirstClosingBrace = indexOfNextClosingBracket + 1;
                            var indexOfNextClosingBrace = currentContent.indexOf(")", indexOfNextClosingBracket + 2);
                            if (indexOfNextClosingBrace > -1) {
                                var lengthOfId = indexOfNextClosingBrace - indexOfFirstClosingBrace + 1; // +1 to include both parenthesis
                                restrictedRanges.push([
                                    i + shiftRight + 1,
                                    indexOfNextClosingBrace, 
                                ]);
                                shiftRight += lengthOfId + 2; // +2 for the []
                            }
                        }
                    }
                }
            }
        }
        var shiftedPosition = position + shiftRight;
        isRestrictedPosition = restrictedRanges.some(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), start = _param[0], end = _param[1];
            return shiftedPosition >= start && shiftedPosition <= end;
        });
    }
    if (!isRestrictedPosition) {
        return (0,_textHelpers__WEBPACK_IMPORTED_MODULE_1__/* .insertAtPosition */ .j0)(currentContent, position + shiftRight, emoji);
    }
    return content || "";
};



/***/ }),

/***/ 14255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vo": function() { return /* binding */ MENTION_REGEX_GLOBAL; },
/* harmony export */   "YA": function() { return /* binding */ mentionIdRegex; },
/* harmony export */   "xA": function() { return /* binding */ MENTION_REGEX; },
/* harmony export */   "yI": function() { return /* binding */ escapeRegex; }
/* harmony export */ });
var MENTION_REGEX = /@\[([^[]+?)]\(([\w\d=]+)\)/;
var MENTION_REGEX_GLOBAL = new RegExp(MENTION_REGEX.source, "g");
var mentionIdRegex = function(id) {
    return new RegExp("@\\[[^\\[]+?]\\(".concat(id, "\\)"), "g");
};
var escapeRegex = function(input) {
    return input.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
};


/***/ }),

/***/ 97346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ActionModal_sr-only--mobile__VoUeq","sr-only":"ActionModal_sr-only__aoWhY","error-message":"ActionModal_error-message__9vTsi","form-inline-edit":"ActionModal_form-inline-edit__FeRPj","form-group":"ActionModal_form-group__fKluu","form-row":"ActionModal_form-row__4UEIy","form-inline":"ActionModal_form-inline__9bfuP","error":"ActionModal_error__fM28f","input-group-append":"ActionModal_input-group-append__XrswW","input-group-currency":"ActionModal_input-group-currency__dDAfA","form-control":"ActionModal_form-control__SNTHx","custom-select":"ActionModal_custom-select__rjYN_","is-invalid":"ActionModal_is-invalid__050SP","is-valid":"ActionModal_is-valid__1ScCd","input-group":"ActionModal_input-group__x6u6w","input-group-text":"ActionModal_input-group-text__DT06u","input-group-prepend":"ActionModal_input-group-prepend__MNhsM","valid-feedback":"ActionModal_valid-feedback__gSs0t","invalid-feedback":"ActionModal_invalid-feedback__rd7t8","form-text":"ActionModal_form-text__BhPxc","label":"ActionModal_label__PDsbu","custom-control":"ActionModal_custom-control__5FLge","custom-control-label":"ActionModal_custom-control-label__vK6wK","custom-control-label--empty":"ActionModal_custom-control-label--empty__Tq0cd","custom-control-input":"ActionModal_custom-control-input__ebI9R","action-modal":"ActionModal_action-modal__j4dyB","action-modal__body":"ActionModal_action-modal__body__2Zi01","action-modal__list":"ActionModal_action-modal__list__xtO9Q","action-modal__close-button":"ActionModal_action-modal__close-button__NTskS"};

/***/ }),

/***/ 11595:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ActionModalItem_sr-only--mobile__uLQQL","sr-only":"ActionModalItem_sr-only__yehCj","error-message":"ActionModalItem_error-message__XtZKf","form-inline-edit":"ActionModalItem_form-inline-edit__EljuP","form-group":"ActionModalItem_form-group__qdvr2","form-row":"ActionModalItem_form-row__5ikbL","form-inline":"ActionModalItem_form-inline__e_EqG","error":"ActionModalItem_error__HO9aW","input-group-append":"ActionModalItem_input-group-append__AZ1xD","input-group-currency":"ActionModalItem_input-group-currency__hM7o_","form-control":"ActionModalItem_form-control__1DWlG","custom-select":"ActionModalItem_custom-select__FiSly","is-invalid":"ActionModalItem_is-invalid__Rhnfo","is-valid":"ActionModalItem_is-valid__Li_Aa","input-group":"ActionModalItem_input-group__v4MZl","input-group-text":"ActionModalItem_input-group-text__ITqPq","input-group-prepend":"ActionModalItem_input-group-prepend__SZN_I","valid-feedback":"ActionModalItem_valid-feedback__rMUIZ","invalid-feedback":"ActionModalItem_invalid-feedback__Vw68I","form-text":"ActionModalItem_form-text__ZBhMw","label":"ActionModalItem_label__b3Org","custom-control":"ActionModalItem_custom-control__Ac4yx","custom-control-label":"ActionModalItem_custom-control-label__jjvOX","custom-control-label--empty":"ActionModalItem_custom-control-label--empty__I2kst","custom-control-input":"ActionModalItem_custom-control-input__KJR43","action-modal-item":"ActionModalItem_action-modal-item__j98Hk","action-modal-item--danger":"ActionModalItem_action-modal-item--danger__Vhgm6","action-modal-item__button":"ActionModalItem_action-modal-item__button__m5BDm"};

/***/ }),

/***/ 12114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Highlight_sr-only--mobile__kuna1","sr-only":"Highlight_sr-only__LYFK5","error-message":"Highlight_error-message__IDp9K","form-inline-edit":"Highlight_form-inline-edit__5CF1q","form-group":"Highlight_form-group__B6Mht","form-row":"Highlight_form-row__2eaE_","form-inline":"Highlight_form-inline__n0H4X","error":"Highlight_error__ScrUV","input-group-append":"Highlight_input-group-append__Lp9JC","input-group-currency":"Highlight_input-group-currency__w5sKE","form-control":"Highlight_form-control__HOTDd","custom-select":"Highlight_custom-select__xrCKR","is-invalid":"Highlight_is-invalid__QS_2G","is-valid":"Highlight_is-valid__rB_jg","input-group":"Highlight_input-group__4Gomq","input-group-text":"Highlight_input-group-text__dnQc9","input-group-prepend":"Highlight_input-group-prepend__ou11Y","valid-feedback":"Highlight_valid-feedback__mDBb7","invalid-feedback":"Highlight_invalid-feedback__B4qgC","form-text":"Highlight_form-text__lQ2PV","label":"Highlight_label__cZQaA","custom-control":"Highlight_custom-control__NggzV","custom-control-label":"Highlight_custom-control-label__3_r8k","custom-control-label--empty":"Highlight_custom-control-label--empty___xl1y","custom-control-input":"Highlight_custom-control-input__Km0ZF","mention__tooltip-inner":"Highlight_mention__tooltip-inner__rKRXY","mention__tooltip":"Highlight_mention__tooltip__y6VZe","user__avatar":"Highlight_user__avatar__RiI9A","mentions-highlight":"Highlight_mentions-highlight__I5j6p","current-user":"Highlight_current-user__Vzlf5"};

/***/ }),

/***/ 82845:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Post_sr-only--mobile__Bgh3o","sr-only":"Post_sr-only___SrZs","error-message":"Post_error-message__5EDUa","form-inline-edit":"Post_form-inline-edit__CVFJE","form-group":"Post_form-group__lBmop","form-row":"Post_form-row__1iSnw","form-inline":"Post_form-inline__ZVJB6","error":"Post_error__FQG9f","input-group-append":"Post_input-group-append__9lZ29","input-group-currency":"Post_input-group-currency__LgiL5","form-control":"Post_form-control__O3wRG","custom-select":"Post_custom-select__8bhD0","is-invalid":"Post_is-invalid__xlzAU","is-valid":"Post_is-valid__riwcb","input-group":"Post_input-group__9cDC2","input-group-text":"Post_input-group-text__O_ZkL","input-group-prepend":"Post_input-group-prepend__4zUuS","valid-feedback":"Post_valid-feedback__QHJa8","invalid-feedback":"Post_invalid-feedback__UaNLV","form-text":"Post_form-text__DyzwV","label":"Post_label__HZGYf","custom-control":"Post_custom-control__alONa","custom-control-label":"Post_custom-control-label__0e0e6","custom-control-label--empty":"Post_custom-control-label--empty__oOx1N","custom-control-input":"Post_custom-control-input___IIPj","post":"Post_post__HGUDA","post__container":"Post_post__container__77Q5S","post__container--full":"Post_post__container--full__zZ2ty","post__content":"Post_post__content__w67vW","post__content--attachment":"Post_post__content--attachment__KTCv4","video__container":"Post_video__container__z0wmx","post__detail":"Post_post__detail__wDEJ6","is-spaces-enabled":"Post_is-spaces-enabled__JIXt_","post__body":"Post_post__body__9OX6f","post__info":"Post_post__info__6rFUh","post__footer":"Post_post__footer__8tZj8","post__space":"Post_post__space___0MEj","post__space__icon":"Post_post__space__icon__jPwU_","total-comments":"Post_total-comments__LVP_T","total-likes":"Post_total-likes__SKn2O","post__detail-action":"Post_post__detail-action__ds9nx","post__detail-action__icon":"Post_post__detail-action__icon__Lvw2x","post__detail-header":"Post_post__detail-header__g_moM","is-following":"Post_is-following__Qb3xN","icon":"Post_icon__aqLzb","post__detail-actions":"Post_post__detail-actions__S3Wgd","post__detail-actions__follow-tag":"Post_post__detail-actions__follow-tag__NTk8l","post__detail-actions__pin-icon":"Post_post__detail-actions__pin-icon___SRsf","post__title":"Post_post__title__KucH4","post__content--button":"Post_post__content--button__KevQB","post__content__text--clamped":"Post_post__content__text--clamped__GTQxo","post__separator":"Post_post__separator__D8ocC","comment-container":"Post_comment-container__XPWOZ","comment-input__wrapper":"Post_comment-input__wrapper__jHtfH","comment-input__avatar":"Post_comment-input__avatar__JcTZb","comment-input__avatar-container":"Post_comment-input__avatar-container__YoIAz","post-comment":"Post_post-comment__PIA0b","post-comment__modal":"Post_post-comment__modal__5nDbj","post-comment__modal-header-text--dark":"Post_post-comment__modal-header-text--dark__uTOMf","post-comment__modal-header-text--light":"Post_post-comment__modal-header-text--light__lqBQ6","has-value":"Post_has-value__02KCr"};

/***/ }),

/***/ 70589:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"PostActions_sr-only--mobile__htvi_","sr-only":"PostActions_sr-only__bTr9A","error-message":"PostActions_error-message__IcK9G","form-inline-edit":"PostActions_form-inline-edit__TuYaq","form-group":"PostActions_form-group__iWIAD","form-row":"PostActions_form-row__OfGD6","form-inline":"PostActions_form-inline__q4MPu","error":"PostActions_error__V1Zfq","input-group-append":"PostActions_input-group-append__06b78","input-group-currency":"PostActions_input-group-currency__IT18k","form-control":"PostActions_form-control__bXLjs","custom-select":"PostActions_custom-select__j2OwF","is-invalid":"PostActions_is-invalid__kZYgk","is-valid":"PostActions_is-valid__aLkul","input-group":"PostActions_input-group__PCPL6","input-group-text":"PostActions_input-group-text__stptd","input-group-prepend":"PostActions_input-group-prepend__5WRBH","valid-feedback":"PostActions_valid-feedback__p5Oba","invalid-feedback":"PostActions_invalid-feedback__T3QDR","form-text":"PostActions_form-text__r38Xd","label":"PostActions_label__YztH9","custom-control":"PostActions_custom-control__JgGmM","custom-control-label":"PostActions_custom-control-label__eca9M","custom-control-label--empty":"PostActions_custom-control-label--empty__hveGf","custom-control-input":"PostActions_custom-control-input__hbuW8","post-actions__button":"PostActions_post-actions__button__M9ZsV","post-actions__button-icon":"PostActions_post-actions__button-icon___z_AF"};

/***/ }),

/***/ 6950:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ReactionButton_sr-only--mobile__VItEx","sr-only":"ReactionButton_sr-only__jvmuK","error-message":"ReactionButton_error-message__iI7Q1","form-inline-edit":"ReactionButton_form-inline-edit__P_b58","form-group":"ReactionButton_form-group__9g559","form-row":"ReactionButton_form-row__In8K2","form-inline":"ReactionButton_form-inline__vCxmW","error":"ReactionButton_error__nHyXi","input-group-append":"ReactionButton_input-group-append__L1pqf","input-group-currency":"ReactionButton_input-group-currency__sMwl7","form-control":"ReactionButton_form-control__tw_AQ","custom-select":"ReactionButton_custom-select__yYmO6","is-invalid":"ReactionButton_is-invalid__agZCa","is-valid":"ReactionButton_is-valid__hNRX_","input-group":"ReactionButton_input-group__v8pVl","input-group-text":"ReactionButton_input-group-text__wfauN","input-group-prepend":"ReactionButton_input-group-prepend__NK16e","valid-feedback":"ReactionButton_valid-feedback__k5ETb","invalid-feedback":"ReactionButton_invalid-feedback__9XLh9","form-text":"ReactionButton_form-text__KJVgG","label":"ReactionButton_label__72fTj","custom-control":"ReactionButton_custom-control__ifciW","custom-control-label":"ReactionButton_custom-control-label__atY2F","custom-control-label--empty":"ReactionButton_custom-control-label--empty__IQy9n","custom-control-input":"ReactionButton_custom-control-input__lP5QJ","comment__reaction-button":"ReactionButton_comment__reaction-button__C37Lw"};

/***/ }),

/***/ 88968:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"UserDetail_sr-only--mobile__RNEa_","sr-only":"UserDetail_sr-only__a9Clh","error-message":"UserDetail_error-message__MXSsz","form-inline-edit":"UserDetail_form-inline-edit__shiXa","form-group":"UserDetail_form-group__5yr2g","form-row":"UserDetail_form-row__wWpUc","form-inline":"UserDetail_form-inline__EkDMg","error":"UserDetail_error__N_PkP","input-group-append":"UserDetail_input-group-append__E8kqW","input-group-currency":"UserDetail_input-group-currency__UbRIz","form-control":"UserDetail_form-control__Mr_Ft","custom-select":"UserDetail_custom-select__4cCCq","is-invalid":"UserDetail_is-invalid___7uwy","is-valid":"UserDetail_is-valid__cKWwV","input-group":"UserDetail_input-group__M9f6B","input-group-text":"UserDetail_input-group-text__otj0Y","input-group-prepend":"UserDetail_input-group-prepend__XZ4n4","valid-feedback":"UserDetail_valid-feedback__R_6BI","invalid-feedback":"UserDetail_invalid-feedback__5Vc_E","form-text":"UserDetail_form-text__geZeT","label":"UserDetail_label___G1Ju","custom-control":"UserDetail_custom-control__n_Vge","custom-control-label":"UserDetail_custom-control-label__TnrlE","custom-control-label--empty":"UserDetail_custom-control-label--empty__vAl6D","custom-control-input":"UserDetail_custom-control-input__irLEV","user-detail":"UserDetail_user-detail__aXat9","user-detail__edit":"UserDetail_user-detail__edit__tSGi6","user-detail__avatar":"UserDetail_user-detail__avatar__iCGcJ","user-detail__reply":"UserDetail_user-detail__reply__ysW2L","user-detail__name":"UserDetail_user-detail__name__LQwQn","user-detail__label":"UserDetail_user-detail__label__YU0MU","user-detail__role":"UserDetail_user-detail__role__xCJqU","user-detail__edited":"UserDetail_user-detail__edited__6AD8t","user-detail__total-replies":"UserDetail_user-detail__total-replies__QweA_","user-detail__following":"UserDetail_user-detail__following__H9S42","user-detail__name-moderator":"UserDetail_user-detail__name-moderator__rOb09","user-detail__moderator-badge":"UserDetail_user-detail__moderator-badge__PKWUc"};

/***/ }),

/***/ 4861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"InlineActions_sr-only--mobile__oAwF5","sr-only":"InlineActions_sr-only__pOnr3","error-message":"InlineActions_error-message__FCI2b","form-inline-edit":"InlineActions_form-inline-edit__sDmoj","form-group":"InlineActions_form-group__uYVYg","form-row":"InlineActions_form-row__B3j5b","form-inline":"InlineActions_form-inline__wEeG9","error":"InlineActions_error__8fdpP","input-group-append":"InlineActions_input-group-append__miXKL","input-group-currency":"InlineActions_input-group-currency__PTy2k","form-control":"InlineActions_form-control__TuXpQ","custom-select":"InlineActions_custom-select__JWlBH","is-invalid":"InlineActions_is-invalid__wpgZp","is-valid":"InlineActions_is-valid__YvscZ","input-group":"InlineActions_input-group__CHzyl","input-group-text":"InlineActions_input-group-text__7CP_t","input-group-prepend":"InlineActions_input-group-prepend__cyvcj","valid-feedback":"InlineActions_valid-feedback__mBS5t","invalid-feedback":"InlineActions_invalid-feedback__aio11","form-text":"InlineActions_form-text__X06uk","label":"InlineActions_label__IpW43","custom-control":"InlineActions_custom-control__DqzHZ","custom-control-label":"InlineActions_custom-control-label__XleFn","custom-control-label--empty":"InlineActions_custom-control-label--empty__CNKNX","custom-control-input":"InlineActions_custom-control-input__GSEIz","container":"InlineActions_container__teSd_","container-left":"InlineActions_container-left__ycFrv","container-right":"InlineActions_container-right__G3i1N","action-button":"InlineActions_action-button__Zehrs","active":"InlineActions_active__E_H8Y","inline-actions__more-actions--button":"InlineActions_inline-actions__more-actions--button__H3zv6","pressed":"InlineActions_pressed__y2d5I","focused":"InlineActions_focused__fhHEG","inline-actions__item":"InlineActions_inline-actions__item__rLkfX","dropdown-menu__item":"InlineActions_dropdown-menu__item__p2BkT","inline-actions__separator":"InlineActions_inline-actions__separator__Qtzx_","inline-actions--toggle":"InlineActions_inline-actions--toggle__V8XAh","compact-mode":"InlineActions_compact-mode__F0KFV","inline-actions--active-toggle":"InlineActions_inline-actions--active-toggle__8dhsv"};

/***/ }),

/***/ 35330:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Modal_sr-only--mobile__eokwy","sr-only":"Modal_sr-only__IrpXt","error-message":"Modal_error-message__AStAm","form-inline-edit":"Modal_form-inline-edit__JE0cN","form-group":"Modal_form-group__iOldY","form-row":"Modal_form-row__XwycR","form-inline":"Modal_form-inline__s43Nr","error":"Modal_error__qqU2V","input-group-append":"Modal_input-group-append__W_jHM","input-group-currency":"Modal_input-group-currency__zzeYh","form-control":"Modal_form-control__VewJS","custom-select":"Modal_custom-select__zy42f","is-invalid":"Modal_is-invalid__TUGK9","is-valid":"Modal_is-valid__oQGae","input-group":"Modal_input-group__SfEk9","input-group-text":"Modal_input-group-text__0VK1q","input-group-prepend":"Modal_input-group-prepend__I_Uqj","valid-feedback":"Modal_valid-feedback__ECE1m","invalid-feedback":"Modal_invalid-feedback__ZZl5M","form-text":"Modal_form-text__j5TKR","label":"Modal_label__g42Cg","custom-control":"Modal_custom-control__o05rR","custom-control-label":"Modal_custom-control-label__LKEHv","custom-control-label--empty":"Modal_custom-control-label--empty__O_oPD","custom-control-input":"Modal_custom-control-input__26GdC","modal":"Modal_modal__KpzhD","modal__header":"Modal_modal__header__jeavZ","has-title":"Modal_has-title__KooDk","modal__header__close-button":"Modal_modal__header__close-button__ZPkNo","modal__body":"Modal_modal__body__yRfMT","no-padding":"Modal_no-padding__uabdQ","modal__footer":"Modal_modal__footer__xc3ck","overlay":"Modal_overlay__RA50U"};

/***/ })

}]);